import { useAuth0 } from "@auth0/auth0-react";

import { $api } from "@/lib/api";
import type { Organization } from "@/modules/auth/types/organization.types";

interface UseUserOrganizationsReturn {
  currentOrganization: Organization | null;
  availableOrganizations: Organization[];
  isLoading: boolean;
}

/**
 * Hook to fetch organization data from the API.
 *
 * Only with a session: `ExtensionOrgSync` mounts it on every route, /login
 * included, and a request without a token makes the API middleware start its
 * own login — one without the invitation, which replaces LoginScreen's and
 * sends an invitee to the plain login page instead of the signup.
 */
export const useUserOrganizations = (): UseUserOrganizationsReturn => {
  const { isAuthenticated } = useAuth0();
  const { data, isLoading } = $api.useQuery(
    "get",
    "/v1/users/me/organizations",
    {},
    { enabled: isAuthenticated },
  );

  return {
    currentOrganization: (data?.currentOrganization as Organization) ?? null,
    availableOrganizations:
      (data?.organizations as unknown as Organization[]) ?? [],
    isLoading,
  };
};
